import React,{ useState} from 'react';
import '../css/ColorPickerTool.css';
import Header from './Header';
import Footer from './Footer';

export default function ColorPickerTool()
{
	const[hex,setHex] = useState('#3498db');

	const hexToRgba = (hex) => {
		let r = 0,g = 0,b = 0;

		if(hex.length === 4)
		{
			r = parseInt(hex[1]+hex[1],16);
			g = parseInt(hex[2]+ hex[2],16);
			b = parseInt(hex[3] + hex[3], 16);
		}
		else if(hex.length === 7)
		{
			r = parseInt(hex.slice(1, 3), 16);
      		g = parseInt(hex.slice(3, 5), 16);
      		b = parseInt(hex.slice(5, 7), 16);
		}

		return `rgba(${r}, ${g}, ${b}, 1)`;
	};

	const hexToRgb = (hex) => {
		let r = 0,g = 0,b = 0;

		if(hex.length === 4)
		{
			r = parseInt(hex[1]+hex[1],16);
			g = parseInt(hex[2]+ hex[2],16);
			b = parseInt(hex[3] + hex[3], 16);
		}
		else if(hex.length === 7)
		{
			r = parseInt(hex.slice(1, 3), 16);
      		g = parseInt(hex.slice(3, 5), 16);
      		b = parseInt(hex.slice(5, 7), 16);
		}

		return `rgb(${r}, ${g}, ${b})`;
	};

	return(
		<>
		<Header />
		<div className="color-picker-container">
			<h2>Color Picker Tool</h2>
			<p>Color Code Finder is your ultimate tool for selecting, identifying, and copying color codes in a fast, intuitive, and efficient way. Whether you're a web developer, graphic designer, digital artist, or just someone who loves working with color, this tool makes it incredibly easy to pick a color and instantly see its values in multiple formats including HEX, RGB, and RGBA.</p>
      		<h5>Choose Color</h5>
      		<input
        			type="color"
        			value={hex}
        			onChange={(e) => setHex(e.target.value)}
        			className="color-input"
      		/>
      		<div className="color-values">
        		<p><strong>HEX:</strong> {hex}</p>
        		<p><strong>RGBA:</strong> {hexToRgba(hex)}</p>
        		<p><strong>RGB:</strong> {hexToRgb(hex)}</p>
      		</div>
    	</div>
    	<Footer />
    	</>
	);
}

